<template>
  <div>
    <p>{{ text }}</p>
    <hr class="mt-4 mb-4">
    <div class="vx-col w-full mb-3">
      <label>Введите слово <span class="font-medium">{{ word }}</span></label>
      <vs-input
        class="w-full"
        v-model="value"
        :danger="!!error"
        :danger-text="error"

      />
    </div>
    <div class="vx-col w-full mb-3 mt-base flex items-center justify-center flex-wrap">
      <vs-button @click="onSubmit()">Перегенерировать</vs-button>
    </div>
  </div>
</template>

<script>

import modalContext from "@/mixins/modalContext";

const words = ['Меркурий', 'Венера', 'Земля', 'Марс', 'Юпитер', 'Сатурн', 'Уран', 'Нептун'];

export default {
  name:   "ConfirmWordPopup",
  props:  ['text', 'onAccept'],
  mixins: [modalContext],
  data() {
    return {
      word:  words[Math.floor(Math.random() * words.length)],
      value: '',
      error: null,
    };
  },
  methods: {
    onSubmit() {
      if (this.value !== this.word) {
        this.error = 'Введенное слово не совпадает';
        return;
      }
      this.error = '';
      const result = this.onAccept();
      if (result && result.then) {
        result.then(() => this.modalResolve());
      } else {
        this.modalResolve();
      }
    },
  },
};
</script>

<style scoped>

</style>
